// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/payment-process/payment-process.less
// module id = 4160
// module chunks = 0